module.exports = __webpack_public_path__ + "img/itx-file-type-msg.e181e06d.svg";